import React, { useRef, useState, useEffect, useContext } from "react";
import { createPortal } from "react-dom";
import CoursesInPlace from '../SidebarMenuItems/CoursesInPlace';
import { PageNavContext } from '../FunctionalPageLoginStart';
import "./popupsright.css";
import bazeleconta from "../images/bazeleconta.png";
import bazelecontaone from "../images/bazelecontaone.png";
import contafinanciaraone from "../images/contafinanciaraone.png";

const allCourses = [
  { id: 1, name: 'Bazele contabilitatii', icon: bazelecontaone, color: 'blue' },
  { id: 2, name: 'Contabilitate financiara', icon: contafinanciaraone, color: 'orange' },
];

const BCButtonWithDropdown = () => {
  const btnRef = useRef(null);
  const popupRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [enrolledCourses, setEnrolledCourses] = useState(() => {
    const saved = localStorage.getItem('enrolledCourses');
    return saved ? JSON.parse(saved) : [1];
  });
  const pageNav = useContext(PageNavContext);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleCoursesUpdate = (e) => {
      setEnrolledCourses(e.detail);
    };
    window.addEventListener('coursesUpdated', handleCoursesUpdate);
    return () => window.removeEventListener('coursesUpdated', handleCoursesUpdate);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (open) {
      document.body.classList.add("stats-popup-open");
    } else {
      document.body.classList.remove("stats-popup-open");
    }

    return () => {
      document.body.classList.remove("stats-popup-open");
    };
  }, [open]);

  return (
    <div className="first-main-pagi-bc-wrapper">
      {/* BUTON */}
      <div
        ref={btnRef}
        className="first-main-pagi-icon-bc"
        onClick={() => setOpen(!open)}
      >
        <img src={bazeleconta} alt="bc" 
        className="first-main-pagi-stats-icon-lessons"
        />
      </div>

      {open && createPortal(
        <>
          <div
            className="first-main-pagi-overlay"
            onClick={() => setOpen(false)}
          />

          <div
            ref={popupRef}
            className={`first-main-pagi-popup first-main-pagi-bc-popup ${
              isMobile ? "mobile" : "desktop"
            }`}
          >
            <div className="first-main-pagi-popup-header">Cursurile mele</div>

            {allCourses
              .filter(course => enrolledCourses.includes(course.id))
              .map(course => (
                <div key={course.id} className="first-main-pagi-popup-item">
                  <span className={`first-main-pagi-popup-icon course-icon-wrapper ${course.color}`}>
                    <img src={course.icon} alt={course.name} className="first-main-pagi-stats-icon-lessons" />
                  </span> 
                  {course.name}
                </div>
              ))
            }

            <div className="first-main-pagi-popup-item add" onClick={() => pageNav && pageNav('CoursesInPlace')}>
              <span className="first-main-pagi-popup-icon">＋</span> Adauga curs
            </div>
          </div>
        </>,
        document.body
      )}
      {/* Modal logic removed, now handled as main page */}
    </div>
  );
};

export default BCButtonWithDropdown;
